import Hero from "./Hero";
import About from "./About";
import Contact from "./Contact";
import Article from "./Article";
import Investment from "./Investment";
import Sales from "./Sales";

function Home() {
  return (
    <div>
      <Hero />
      <Investment />
      <Sales />
      <About />
      <Contact />
      <Article />
    </div>
  );
}

export default Home;
